import styled, { css } from "styled-components";
import React from "react";
import { Flex, Type } from "@ebscois/react-component-library";

const defaultTextColor = css`
  ${({ theme }) => `
    color: ${theme.colors.gray800}
  `}
`;

export const StyledNoteWidget = styled(({ shouldShowAddButton, ...rest }) => (
  <div {...rest} />
))`
  display: inline-block;
  color: ${({ theme }) => theme.colors.gray800};
  ${(props) => `
    width: ${props.shouldShowAddButton ? "auto" : "100%"};
  `}
`;

export const StyledNoteContentContainer = styled(Flex)`
  word-break: break-word;
  padding: ${({ theme }) => theme.space.sm};

  ${({ isRichText }) => !isRichText && `white-space: pre-line;`}

  ul {
    list-style: disc;
  }

  ol {
    list-style: decimal;
  }
  ol,
  ul {
    margin-top: 0.5rem;
    margin-bottom: 0.75rem;
    margin-left: 1.25rem;
  }
  sup {
    font-size: ${(props) => props.theme.font.size.xs};
    vertical-align: super;
  }

  sub {
    font-size: ${(props) => props.theme.font.size.xs};
    vertical-align: sub;
  }
  a {
    color: ${({ theme }) => theme.colors.anchor};
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }
  em {
    font-style: italic;
  }
  p {
    margin: 0 0 0.75rem 0;
  }
  ${defaultTextColor};
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: ${({ theme }) => theme.space.md};
  }
`;

export const StyledEditHistoryContainer = styled(Flex)`
  padding: ${({ theme }) => theme.space.sm};
  width: 100%;
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: ${({ theme }) => theme.space.md};
  }
  @media print {
    max-width: 33%;
  }
`;

export const StyledNoteContainer = styled(Flex)`
  background-color: ${({ theme }) => theme.colors.gray100};
  ${defaultTextColor};
  margin-top: ${({ theme }) => theme.space.lg};
`;

export const StyledType = styled(Type)`
  ${defaultTextColor};
`;
